import isEqual from 'lodash-es/isEqual';

import { LanguageKeys } from 'src/common/constants/languages';
import {
  IPageDocument,
  normalizePageDocument,
} from 'src/helpers/pageDocumentUtils';
import {
  normalizeMenuLocations,
} from 'src/helpers/publicPageMenuLocations';
import {
  resolveFullPathsFromSegments,
} from 'src/helpers/publicPageUtils';
import { IBasePublicPage, IPublicPage } from 'src/interfaces/PublicPage';

export interface PageEditorDirtySnapshot {
  pageMeta: ReturnType<typeof normalizePageMetaForDirtyCheck>;
  document: IPageDocument;
}

function normalizePageMetaForDirtyCheck(
  form: IBasePublicPage,
  pathSegments: Record<LanguageKeys, string>,
  publicPagesById?: Record<string, IPublicPage>,
) {
  return {
    key: form.key,
    kind: form.kind,
    shell: form.shell ?? 'default',
    published: form.published,
    contentKey: (form.contentKey || form.key || '').trim(),
    redirectTo: form.redirectTo ?? null,
    paths: resolveFullPathsFromSegments(pathSegments, form, publicPagesById),
    menu: {
      icon: form.menu.icon,
      labels: form.menu.labels,
      menuLocations: normalizeMenuLocations(form.menu),
      parentId: form.menu.parentId ?? null,
    },
    sections: form.sections,
  };
}

export function buildPageEditorSnapshot(
  form: IBasePublicPage,
  pathSegments: Record<LanguageKeys, string>,
  document: IPageDocument,
  publicPagesById?: Record<string, IPublicPage>,
): PageEditorDirtySnapshot {
  return {
    pageMeta: normalizePageMetaForDirtyCheck(form, pathSegments, publicPagesById),
    document: normalizePageDocument({
      blocks: document.blocks,
      heroSettings: document.heroSettings,
    }),
  };
}

export function isPageEditorDirty(
  current: PageEditorDirtySnapshot,
  saved: PageEditorDirtySnapshot | null,
): boolean {
  if (!saved) return false;
  return !isEqual(current, saved);
}
